import { render, staticRenderFns } from "./THGDonationProjectsCheckboxGroup.vue?vue&type=template&id=7b63e4bf"
import script from "./THGDonationProjectsCheckboxGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGDonationProjectsCheckboxGroup.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports